import NavigationAdmin from './NavigationAdmin'
import Breadcrumbs from './Breadcrumbs'
import ColorMode from './ColorMode'
import Fullscreen from './Fullscreen'
import UserInfo from './UserInfo'
import { Outlet } from 'react-router-dom'
import { Suspense } from 'react'

const ContentFallback = () => (
  <div className="d-flex flex-column align-items-center justify-content-center gap-3 py-5 text-body-secondary" role="status" aria-live="polite">
    <div className="spinner-border text-primary" aria-hidden="true"></div>
    <div>Načítám data…</div>
  </div>
)

const LayoutAdmin = ({ user, setUser }) => {
  return (
    <>
      {/* Navigace */}
      <NavigationAdmin user={user} setUser={setUser} />

      <main className="main-admin m-0 mt-4 m-xl-3 px-4 py-xl-2">        

        <div className="row d-flex align-items-center justify-content-between mb-0 admin-toolbar">
          {/* Nadpis a breadcrumbs */}
          <div className="col">
            <Breadcrumbs />            
          </div>
          
          {/* Uživatelský box */}
          <div className="col-auto d-none d-md-flex align-items-center align-self-start gap-2 admin-toolbar-userbox">
            <ColorMode />
            <Fullscreen />
            <UserInfo user={user} />
          </div>
        </div>


        {/* Obsah stránky */}
        <Suspense fallback={<ContentFallback />}>
          <Outlet />
        </Suspense>

      </main>
    </>
  )
}

export default LayoutAdmin
